let sizeChart = {
	"thumbnail": "sm",
	"medium": "lg",
	"large": "lg",
	"post": "lg"
};

export default {
	getURL(url, size) {
		url = url.trim();
		if (url.indexOf("aliyun") !== -1) {
			return `${url}?x-oss-process=style/${size}`;
		} else if (url.startsWith("http://") || url.startsWith("https://") || url.startsWith("//")) {
			return url;
		} else {
			return this.getLocal(url, sizeChart[size]);
		}
	},
	getLocal(url, size) {
		try {
			return require(`@/assets/${size}/${url.trim()}`);
		} catch {
			return undefined;
		}
	}
};